import React from 'react';

import FieldText from '../common/FieldText';
import FieldDate from '../common/FieldDate';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';

class ContactAddEditInfo extends React.Component {

  render() {
    const fields = this.props.model.fields;
    const contact = this.props.contact;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>{this.props.module.model_name} Information</h2></div>
        
        <FieldText key="firstname" id="firstname" field={fields.firstname}
          value={contact.firstname} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="middlename" id="middlename" field={fields.middlename}
          value={contact.middlename} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="lastname" id="lastname" field={fields.lastname}
          value={contact.lastname} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="gender" id="gender" field={fields.gender}
          value={contact.gender} onValueChange={onValueChange} inValid={inValid} />

        <FieldDate key="dob" id="dob" field={fields.dob}
          value={contact.dob} onValueChange={onValueChange} inValid={inValid} />

        <FieldDate key="anniversary" id="anniversary" field={fields.anniversary}
          value={contact.anniversary} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="responsible_person" id="responsible_person"
          field={fields.responsible_person} value={contact.responsible_person}
          onValueChange={onValueChange} inValid={inValid} />

        {/* <FieldMultiSelect key="interested_product" id="interested_product"
          field={fields.interested_product} value={contact.interested_product}
          onValueChange={onValueChange} inValid={inValid} /> */}

        <FieldSelect key="source" id="source" field={fields.source}
          value={contact.source} onValueChange={onValueChange} inValid={inValid} />

        <FieldToggle key="email_opt" id="email_opt" field={fields.email_opt}
          value={contact.email_opt} onValueChange={onValueChange} inValid={inValid} />

        <FieldToggle key="sms_opt" id="sms_opt" field={fields.sms_opt}
          value={contact.sms_opt} onValueChange={onValueChange} inValid={inValid} />
      </>
    );
  }
}
export default ContactAddEditInfo;